// Classic: today's public site as a website template (ARCHITECTURE §6).
//
// Eager (D10): this module and the four pages that are eager today (Home,
// Schedule, Players, Teams) are in the entry bundle; the other 15 pages keep
// their own lazy chunks. No CSS of its own; brand() returns {} because
// classic keeps applyThemeToDOM's full palette.
//
// Each page is a view over its core controller's VM (site/core/pages/*).

import { defineTemplate } from '../../core/template/defineTemplate'
import LeagueFooter from './components/LeagueFooter'
import { NotFound, PageError, RouteLoading } from './states'
import { ClassicHeader } from './shell'
import { CLASSIC_HOME_SECTIONS } from './home/map'
import { CLASSIC_CHROME } from './chrome'

// Eager pages (in the entry today).
import Home from './pages/Home'
import Schedule from './pages/Schedule'
import Players from './pages/Players'
import Teams from './pages/Teams'

const classicTemplate = defineTemplate({
  id: 'classic',
  brand: () => ({}),
  shell: { Header: ClassicHeader, Footer: LeagueFooter },
  states: { RouteLoading, PageError, NotFound },
  pages: {
    home: { eager: Home },
    schedule: { eager: Schedule },
    stats: { load: () => import('./pages/Stats') },
    game: { load: () => import('./pages/GameDetail') },
    players: { eager: Players },
    player: { load: () => import('./pages/PlayerDetail') },
    teams: { eager: Teams },
    team: { load: () => import('./pages/TeamDetail') },
    blog: { load: () => import('./pages/Blog') },
    page: { load: () => import('./pages/PageDetail') },
    gallery: { load: () => import('./pages/Gallery') },
    sponsor: { load: () => import('./pages/SponsorDetail') },
    venues: { load: () => import('./pages/Venues') },
    venue: { load: () => import('./pages/VenueDetail') },
    liveEvents: { load: () => import('./pages/LiveEvents') },
    liveEvent: { load: () => import('./pages/LiveEventDetail') },
    tickets: { load: () => import('./pages/TicketsIndex') },
    sale: { load: () => import('./pages/SalePage') },
    // Registration plan step 2 (route only with the registration add-on).
    signIn: { load: () => import('./pages/SignIn') },
    registrations: { load: () => import('./pages/Registrations') },
    registration: { load: () => import('./pages/Registration') },
    // Registration plan step 9 (routes only with the registration add-on).
    account: { load: () => import('./pages/Account') },
    forgotPassword: { load: () => import('./pages/ForgotPassword') },
    resetPassword: { load: () => import('./pages/ResetPassword') },
    join: { load: () => import('./pages/Join') },
    // The private site's wall (registration step 33): no route, no Frame.
    membersOnly: { load: () => import('./pages/MembersOnly') },
  },
  chrome: CLASSIC_CHROME,
  // Classic's Home renders these synchronously (it imports them directly);
  // the loader hands the same views to the contract tests and the workbench.
  homeSections: async () => ({ default: CLASSIC_HOME_SECTIONS }),
})

export default classicTemplate
